import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCountries } from '../actions/countries';
import { getForm, completeDeclaration, resetForm } from '../actions/form';
import { keepAlive as keepAliveAction } from '../actions/keep-alive';
import KYCForm from '../components/kyc-form';
export default connect(state => ({
  form: state.form.fetch,
  countries: state.countries.fetch,
  submitForm: state.form.completeForm,
  keepAlive: state.keepAlive.keepAlive
}), dispatch => bindActionCreators({
  getForm,
  getCountries,
  completeDeclaration,
  keepAliveAction,
  resetForm
}, dispatch))(KYCForm);